import { gql } from 'graphql-request';

/**
 * The one selection set for EventExport rows, shared by every document that
 * returns them. The normalized cache keys objects by id, so two call sites
 * selecting different subsets of the same row would leave a partial first
 * write that later full responses never heal (same rule as LayoutDefinition).
 */
export const EventExportFragment = gql`
  fragment EventExport on EventExport {
    id
    eventId
    platform
    calendarId
    externalId
    externalLink
    sequence
    autoUpdate
  }
`;
